import React, { useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { TextField } from '@material-ui/core';
import { translate } from 'containers/services/translate';
import messages from 'containers/CourtManagerLegalProceedings/JudgementAdd/messages';
import { RefusalDialogWrapper } from 'containers/CourtManagerLegalProceedings/JudgementAdd/styled-components';
import { toast } from 'react-toastify';
import { pushTo } from 'containers/services/routes-helper';
import { PAGES } from 'routes';
import { PROCEDURE_STATUSES } from 'containers/data-structure';
import { PROCEDURE_TYPES } from 'containers/LawyerLegalProceedingsPage/constants';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';

export interface RejectionDialogProps {
  intl: IntlShape;
  isRejectionDialogOpen: boolean;
  setIsRejectionDialogOpen: Function;
  requestValidateJudgementOnMerits: Function;
  lawyer: string;
  claimId: number;
  claimNumber: string;
  judiciaryProcessId: number;
  jomId: number;
  isAppeal?: boolean;
  setJomStatus?: Function;
  judgementId: number;
  isMultiple?: boolean | undefined;
  judgementDate?: string | undefined;
  isFirst?: boolean | undefined;
  setIsButtonRedirect?: Function;
  setOpenFeeNoteDialog: Function;
}

export const RejectionDialog: React.FC<RejectionDialogProps> = (
  props,
): JSX.Element => {
  const [rejectionReason, setRejectionReason] = useState<string>('');

  const handleChangeRejectionReason = (
    event: React.ChangeEvent<{
      value: string;
    }>,
  ) => setRejectionReason(event.target.value);

  const handleValidation = () => {
    props.setIsButtonRedirect && props.setIsButtonRedirect(true);

    const decision = {
      status: PROCEDURE_STATUSES.REJECTED,
      rejectionReason,
      claimId: Number(props.claimId),
      claimNumber: props.claimNumber,
      jomId: props.jomId,
      procedureType: !props.isAppeal
        ? PROCEDURE_TYPES.FIRST_INSTANCE
        : PROCEDURE_TYPES.APPEAL,
      judiciaryProcessId: props.judiciaryProcessId,
      judgementId: props.judgementId,
      sagisEvaluations: [],
      isMultiple: props.isMultiple,
      jomDate: props.judgementDate,
      isFist: props.isFirst,
      isInboxesActive: featureService.hasFeature(
        FEATURES.ATTRIBUTION_INBOXES_MANAGER,
      ),
      isTrackingActive: featureService.hasFeature(
        FEATURES.TRACKING_ACTIONS_USER,
      ),
    };
    if (props.setJomStatus) props.setJomStatus(PROCEDURE_STATUSES.REJECTED);
    props.requestValidateJudgementOnMerits(decision, handleSuccessCallback);
  };

  const handleSuccessCallback = () => {
    toast.success(
      translate(messages.courtManagerRefusalDialogSuccessMessage, props, {
        lawyer: props.lawyer,
      }),
    );
    props.setIsRejectionDialogOpen(false);
    if (!featureService.hasFeature(FEATURES.EVOLUTIONS_FEE_NOTE)) {
      pushTo(PAGES.COURT_MANAGER_ASSIGNED_CLAIM)();
    } else {
      /* istanbul ignore next */
      featureService.hasFeature(FEATURES.EVOLUTIONS_FEE_NOTE) &&
        props.setOpenFeeNoteDialog(true);
    }
  };

  return (
    <RefusalDialogWrapper
      className="refusal-content"
      handleValidate={handleValidation}
      handleClose={() => props.setIsRejectionDialogOpen(false)}
      title={translate(messages.courtManagerRefuseDialogTitle, props)}
      cancelTitle={translate(
        messages.courtManagerRefusalDialogReasonCancel,
        props,
      )}
      confirmTitle={translate(
        messages.courtManagerRefusalDialogReasonValidate,
        props,
      )}
      open={props.isRejectionDialogOpen}
      validateButtonDisabled={!rejectionReason}
    >
      <div className="reason-wrapper">
        <TextField
          id="judgement-on-merits-rejection-reason"
          label={translate(
            messages.courtManagerRefusalDialogReasonLabel,
            props,
          )}
          onChange={handleChangeRejectionReason}
          value={rejectionReason}
          fullWidth
        />
      </div>
    </RefusalDialogWrapper>
  );
};

export default injectIntl(RejectionDialog);
